export const backend_url = process.env.REACT_APP_BACKEND_URL || "https://api.lexmom.com";
export const backend_api = process.env.REACT_APP_BACKEND_API || `${backend_url}/api/v1/`;
